import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';

export const loadImmigrationProfessional = createAsyncThunk(
    'api/immigration_professional/{consultant_id}',
    async (consultantId: string) => await api.immigrationProfessional.get(consultantId)
);
